module.exports = __webpack_public_path__ + "img/1.fb794c40.png";